<template>
  <div class="dashboard">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">Dashboard</v-card-title>
      <v-card-text class="parent">
        <v-row>
          <v-col cols="12" md="8">
            <v-card class="severity_trend">
              <v-card-title>
                <p>Severity Trend</p>
                <div class="not_mobile">
                  <div class="calendar">
                    <div class="prev_btn">
                      <v-btn @click="selectBackward"
                        ><font-awesome-icon class="prev" icon="chevron-left"
                      /></v-btn>
                    </div>
                    <div class="calendar_week">
                      <font-awesome-icon class="week" icon="calendar-week" />
                      <p>{{ dateoption.name }}</p>
                    </div>
                    <div class="next_btn">
                      <v-btn @click="selectForward"
                        ><font-awesome-icon class="next" icon="chevron-right"
                      /></v-btn>
                    </div>
                  </div>
                  <p class="total">
                    Total: <span class="bold">{{ this.chartTotal }}</span>
                  </p>
                </div>
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="bar"
                  height="220"
                  :options="chartOptions"
                  :series="series"
                />
                <div class="mobile">
                  <div class="calendar">
                    <div class="prev_btn">
                      <v-btn
                        ><font-awesome-icon class="prev" icon="chevron-left"
                      /></v-btn>
                    </div>
                    <div class="calendar_week">
                      <font-awesome-icon class="week" icon="calendar-week" />
                      <p>This week</p>
                    </div>
                    <div class="next_btn">
                      <v-btn
                        ><font-awesome-icon class="next" icon="chevron-right"
                      /></v-btn>
                    </div>
                  </div>
                  <p class="total">
                    Total: <span class="bold">{{ this.total_lifetime }}</span>
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="vendor_risk">
              <v-card-title>Vendor Risk Scorecard</v-card-title>
              <v-card-text>
                <table>
                  <thead>
                    <tr>
                      <th>VENDOR</th>
                      <th># OF CRITICAL SEVERITY</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="vendor in vendors" :key="vendor.id">
                      <td>
                        <span class="bold">{{ vendor.id + ". " }}</span
                        > {{ vendor.name }}
                      </td>
                      <td>{{ vendor.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <div class="upload_dashboard">
              <div class="not_mobile">
                <div class="drop" v-if="profile.role != 4">
                  <div id="file-drag-drop">
                    <form ref="fileform">
                      <div class="document_icon"></div>
                      <div class="drop_file">
                        <p class="drop-files">Drop</p>
                        <span> file</span>
                        <p class="drop-files">here</p>
                      </div>
                      <p class="drop-files">to upload</p>
                      <p class="succession">{{ this.successMessage }}</p>
                      <p class="error">{{ this.errorMessage }}</p>
                    </form>
                  </div>
                </div>
                <div class="number">
                  <div class="completed">
                    <p class="quantity">{{ this.completed_lifetime }}</p>
                    <p>Completed Lifetime</p>
                    <p class="bold">Scans & Reports</p>
                  </div>
                  <div class="total">
                    <p class="quantity">{{ this.total_lifetime }}</p>
                    <p>Total Lifetime</p>
                    <p class="bold">Vulnerabilities</p>
                  </div>
                </div>
                <div class="pie_chart">
                  <span class="low">
                    <span class="num">{{ this.risks[3] }}</span
                    ><br />
                    <span class="bold">Low</span>
                  </span>
                  <span class="medium">
                    <span class="num">{{ this.risks[2] }}</span
                    ><br />
                    <span class="bold">Medium</span>
                  </span>
                  <span class="high">
                    <span class="num">{{ this.risks[1] }}</span
                    ><br />
                    <span class="bold">High</span>
                  </span>
                  <span class="critical">
                    <span class="num">{{ this.risks[0] }}</span
                    ><br />
                    <span class="bold">Critical</span>
                  </span>
                  <span
                    v-if="
                      this.risks[0] +
                        this.risks[1] +
                        this.risks[2] +
                        this.risks[3] ==
                        0
                    "
                    class="empty"
                    >Empty Data</span
                  >
                  <apexchart
                    type="donut"
                    height="270"
                    :options="riskOptions"
                    :series="risks"
                    class="risk"
                  />
                </div>
                <div class="users">
                  <font-awesome-icon class="user-icon" icon="user" />
                  <div class="total-users">
                    <p class="bold">{{ totalusers }}</p>
                    <p>Total Users</p>
                  </div>
                  <div class="active">
                    <p v-if="this.activeusers == 0">
                      <span class="bold">No users</span> were
                    </p>
                    <p v-else-if="this.activeusers == 1">
                      <span class="bold">1 user</span> was
                    </p>
                    <p v-else>
                      <span class="bold">{{ activeusers }} users</span> were
                    </p>
                    <p>active last week.</p>
                  </div>
                </div>
              </div>
              <div class="mobile">
                <div class="number">
                  <div class="completed">
                    <p class="quantity">{{ this.completed_lifetime }}</p>
                    <p>Completed Lifetime</p>
                    <p class="bold">Scans & Reports</p>
                  </div>
                  <div class="total">
                    <p class="quantity">{{ this.total_lifetime }}</p>
                    <p>Total Lifetime</p>
                    <p class="bold">Vulnerabilities</p>
                  </div>
                </div>
                <div class="pie_chart">
                  <span class="low">
                    <span class="num">{{ this.risks[3] }}</span
                    ><br />
                    <span class="bold">Low</span>
                  </span>
                  <span class="medium">
                    <span class="num">{{ this.risks[2] }}</span
                    ><br />
                    <span class="bold">Medium</span>
                  </span>
                  <span class="high">
                    <span class="num">{{ this.risks[1] }}</span
                    ><br />
                    <span class="bold">High</span>
                  </span>
                  <span class="critical">
                    <span class="num">{{ this.risks[0] }}</span
                    ><br />
                    <span class="bold">Critical</span>
                  </span>
                  <apexchart
                    type="donut"
                    height="270"
                    width="200"
                    :options="riskOptions"
                    :series="risks"
                    class="risk"
                  />
                </div>
                <div class="users">
                  <font-awesome-icon class="user-icon" icon="user" />
                  <div class="total-users">
                    <p class="bold">{{ totalusers }}</p>
                    <p>Total Users</p>
                  </div>
                  <div class="active">
                    <p>
                      <span class="bold">{{ activeusers }} users</span> were
                    </p>
                    <p>active last week.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="upload_table">
              <v-card class="uploads">
                <v-card-title>Latest Uploads & Reports</v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="upload_headers"
                    :items="latestuploads"
                    :hide-default-footer="true"
                    :disable-pagination="true"
                    item-key="id"
                  >
                    <template v-slot:item.index="{ item }">
                      <div class="not_mobile">{{ item.index }}</div>
                      <div class="mobile">
                        <div>{{ item.index }}</div>
                        <div class="description">{{ item.description }}</div>
                        <div v-if="item.status == 'Processing'" class="process">
                          {{ item.status }}
                        </div>
                        <div v-if="item.status == 'Completed'" class="complete">
                          Complete
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.description="{ item }">
                      <div class="description">{{ item.description }}</div>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status == 'Processing'" class="process">
                        {{ item.status }}
                      </div>
                      <div v-if="item.status == 'Completed'" class="complete">
                        Complete
                      </div>
                    </template>
                    <template v-slot:item.vendor="{ item }">
                      <div class="not_mobile">{{ item.vendor }}</div>
                      <div class="mobile">
                        <div>{{ item.vendor }}</div>
                        <div>{{ item.submitted }}</div>
                      </div>
                    </template>
                    <template v-slot:item.submitted="{ item }">
                      <div>{{ item.submitted }}</div>
                    </template>
                    <template v-slot:item.risk_rating="{ item }">
                      <div class="not_mobile">
                        <font-awesome-icon
                          class="rating critical"
                          icon="circle"
                          v-if="item.risk_rating == 1"
                        />
                        <font-awesome-icon
                          class="rating high"
                          icon="circle"
                          v-if="item.risk_rating == 2"
                        />
                        <font-awesome-icon
                          class="rating medium"
                          icon="circle"
                          v-if="item.risk_rating == 3"
                        />
                        <font-awesome-icon
                          class="rating low"
                          icon="circle"
                          v-if="item.risk_rating == 4"
                        />
                      </div>
                      <div class="mobile">
                        <font-awesome-icon
                          class="rating critical"
                          icon="circle"
                          v-if="item.rating == 'critical'"
                        />
                        <font-awesome-icon
                          class="rating low"
                          icon="circle"
                          v-if="item.rating == 'low'"
                        />
                        <font-awesome-icon
                          class="rating medium"
                          icon="circle"
                          v-if="item.rating == 'medium'"
                        />
                        <router-link to="/report" class="link"
                          >View</router-link
                        >
                      </div>
                    </template>
                    <template v-slot:item.report="{ item }">
                      <router-link
                        :to="'/configuration/analysis/' + item.id + '/report'"
                      >
                        View
                      </router-link>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="map">
              <div class="map_content">
                <div class="header">
                  <p class="geo">Geographical Enumeration</p>
                  <p class="building">Discovered Buildings</p>
                </div>
                <div id="map" style=""></div>
                <!-- <router-link
                  :to="{
                    name: 'browse',
                    params: {
                      showmap: true,
                      showtable: false,
                      searchbuilding: this.searchbuilding
                    }
                  }"
                >
                  <div id="map" style=""></div>
                </router-link> -->
              </div>
              <div class="search_building">
                <font-awesome-icon class="search_icon" icon="search" />
                <input
                  id="search"
                  type="text"
                  placeholder="Please enter the country"
                  v-model="searchbuilding"
                  v-on:keyup="searchBuilding"
                />
              </div>
            </div>
            <div class="common_cities">
              <v-card class="cities">
                <v-card-title>Most Common Cities</v-card-title>
                <v-card-text>
                  <table>
                    <tbody>
                      <tr v-if="cities.length == 0">
                        <td colspan="7" style="color: rgba(0,0,0, 0.38)">
                          No data available
                        </td>
                      </tr>
                      <tr v-else v-for="city in cities" :key="city.id">
                        <td>
                          <span class="bold">{{ city.id + ". " }}</span
                          >{{ city.name }}
                        </td>
                        <td>{{ city.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // severity chart
      dateoptions: [
        { id: 1, name: "This Week" },
        { id: 2, name: "Last Week" }
      ],
      dateoption: { id: 1, name: "This Week" },
      series: [],
      chartTotal: 0,
      chartOptions: {
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        colors: ["#39b9a9", "#ff6600", "#fec02d", "#d5132f"],
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          show: false,
          maxHeight: 12
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          enabled: false
        },
        legend: {
          position: "bottom"
        }
      },

      // File upload
      successMessage: "",
      errorMessage: "",
      dragAndDropCapable: false,
      files: [],

      // risk chart
      riskOptions: {
        labels: ["Critical", "High", "Medium", "Low"],
        colors: ["#d5132f", "#ff6600", "#fec02d", "#2bb9aa"],
        fill: {
          colors: ["#d5132f", "#ff6600", "#fec02d", "#2bb9aa"]
        },
        responsive: [
          {
            breakpoint: 480
          }
        ],
        plotOptions: {
          pie: {
            customScale: 0.8
          }
        }
      },

      // The latest uploads Table
      upload_headers: [
        { text: "No", align: "center", sortable: false, value: "index" },
        {
          text: "DESCRIPTION",
          align: "left",
          sortable: false,
          value: "description"
        },
        { text: "STATUS", align: "center", sortable: false, value: "status" },
        { text: "VENDOR", align: "center", sortable: false, value: "vendor" },
        {
          text: "SUBMITTED",
          align: "center",
          sortable: false,
          value: "submitted"
        },
        {
          text: "RATING",
          align: "center",
          sortable: false,
          value: "risk_rating"
        },
        { text: "REPORT", align: "center", sortable: false, value: "report" }
      ],
      days_thisweek: [],
      days_lastweek: [],
      searchbuilding: "",
      searchbuildings: []
    };
  },
  mounted() {
    if (this.profile.role != 4) {
      this.dragAndDropCapable = this.determineDragAndDropCapable();
      if (this.dragAndDropCapable) {
        [
          "drag",
          "dragstart",
          "dragend",
          "dragover",
          "dragenter",
          "dragleave",
          "drop"
        ].forEach(
          function(evt) {
            this.$refs.fileform.addEventListener(
              evt,
              function(e) {
                e.preventDefault();
                e.stopPropagation();
              }.bind(this),
              false
            );
          }.bind(this)
        );

        this.$refs.fileform.addEventListener(
          "drop",
          function(e) {
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
              this.files.push(e.dataTransfer.files[i]);
            }

            this.submitFiles();
          }.bind(this)
        );
      }
    }

    this.$store
      .dispatch("getUploadsForDate", {
        filter: 1
      })
      .then(response => {
        this.updateChart(response.data);
      });
    this.$store.dispatch("userStatus");
    this.$store.dispatch("riskVendors");
    this.$store.dispatch("latestUploads");
    this.$store.dispatch("complete_total_Lifetime");
    this.$store.dispatch("getRiskChart");
    this.$store.dispatch("getMostCities");

    // simplemaps_worldmap.load();
    // simplemaps_worldmap.refresh();
    this.updateMap();
  },
  computed: {
    profile() {
      return this.$store.state.user.profile;
    },
    latestuploads() {
      return this.$store.state.dashboard.latestuploads;
    },
    totalusers() {
      return this.$store.state.dashboard.totalusers;
    },
    activeusers() {
      return this.$store.state.dashboard.last_activeusers;
    },
    vendors() {
      return this.$store.state.dashboard.vendor_riskscore;
    },
    completed_lifetime() {
      return this.$store.state.dashboard.completed_lifetime;
    },
    total_lifetime() {
      return this.$store.state.dashboard.total_lifetime;
    },
    risks() {
      return this.$store.state.dashboard.riskCharts;
    },
    cities() {
      return this.$store.state.dashboard.mostcities;
    }
  },
  methods: {
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    submitFiles() {
      this.successMessage = "";
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("file", file);
      }
      this.successMessage = "Uploading";
      this.$store
        .dispatch("fileUpload", formData)
        .then(() => {
          this.successMessage = "You have uploaded the file successfully.";
          this.uploadTitle = "Upload";
          this.$store
            .dispatch("getUploadsForDate", {
              filter: 1
            })
            .then(response => {
              this.updateChart(response.data);
            });
          this.$store.dispatch("complete_total_Lifetime");
          this.$store.dispatch("getRiskChart");
          this.$store.dispatch("latestUploads");
        })
        .catch(error => {
          this.errorMessage = "File Uploading Failure.";
          this.uploadTitle = "Upload";
        });
    },
    selectForward() {
      let dateId = this.dateoption.id;
      if (dateId == 2) {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 1);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("getUploadsForDate", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 2);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("getUploadsForDate", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      }
    },
    selectBackward() {
      let dateId = this.dateoption.id;
      if (dateId == 1) {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 2);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("getUploadsForDate", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 1);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("getUploadsForDate", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      }
    },
    updateChart(data) {
      let selected_days = [];
      data.dates.map(item => {
        let upload = item.split("-");
        item = [upload[1], upload[2], upload[0]].join("/");
        selected_days.push(item);
      });
      let counts = data.counts;
      this.series = counts;
      this.chartTotal = data.total;
      this.chartOptions = {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "75%",
            barHeight: "50%",
            distributed: false,
            dataLabels: {
              position: "top"
            }
          }
        },
        stroke: {
          show: true,
          width: -1,
          colors: ["transparent"]
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        colors: ["#39b9a9", "#fec02d", "#ff6600", "#d5132f"],
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        xaxis: {
          categories: selected_days
        },
        yaxis: {
          show: false,
          maxHeight: 12
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          enabled: false
        },
        legend: {
          position: "bottom"
        }
      };
    },
    searchBuilding(e) {
      if (e.keyCode === 13) {
        this.$router.push({
          name: 'browse',
          params: {
            showmap: true,
            showtable: false,
            searchbuilding: this.searchbuilding
          }
        });
        // this.updateMap()
      }
    },
    updateMap() {
      this.$store
        .dispatch("getWorldMap")
        .then(response => {
          simplemaps_worldmap_mapdata.main_settings.state_url = "";
          simplemaps_worldmap_mapdata.main_settings.location_url = "";
          simplemaps_worldmap_mapdata.main_settings.manual_zoom = "yes";
          console.log(simplemaps_worldmap_mapdata.main_settings)
          response.data.forEach((item, i) => {
            simplemaps_worldmap_mapdata.locations[i] = {
              name: item.country,
              lng: item.lng,
              lat: item.lat,
              description: "Count: " + item.count,
              color: "#39b7eb",
              url: "",
              size: "35",
              type: "circle"
            };
          })
          simplemaps_worldmap.load();
          simplemaps_worldmap.refresh();
        });
    }
  }
};
</script>
